import dynamic from 'next/dynamic'
import HyperAI from '@/components/pages/LandingPage/Homepage/hyper-ai'
import TestimonialSingleCard from '../testimonials/TestimonialSingleCard'

const TaskWriter = dynamic(() => import('@/components/pages/LandingPage/Homepage/task-writer'))
const Inbox = dynamic(() => import('@/components/pages/LandingPage/inbox'))
const AIModels = dynamic(() => import('@/components/pages/LandingPage/Homepage/ai-models'))
const Dictation = dynamic(() => import('@/components/pages/LandingPage/Homepage/dictation'))
const DictateAndImprove = dynamic(() => import('@/components/pages/LandingPage/Homepage/dictate-and-improve'))
const Testimonials2 = dynamic(() => import('@/components/pages/LandingPage/testimonials/Testimonials2'))
const PricingModule = dynamic(() => import('@/components/pages/Pricing/pricing-module'))
const TimeSavings = dynamic(() => import('@/components/pages/LandingPage/Homepage/time-savings'))
const UTMCookieHandler = dynamic(() => import('@/components/analytics/StoreUTM'))
const AIChatFeature = dynamic(() => import('@/components/pages/LandingPage/Homepage/ai-chat-feature'))

interface ClientSideLoadedProps {
    hyperAITitle?: string
    hyperAISubtitle?: string
    taskWriterTitle?: string
    taskWriterSubtitle?: string
    inboxTitle?: string
    inboxSubtitle?: string
    aiModelsTitle?: string
    aiModelsSubtitle?: string
    dictationTitle?: string
    dictationSubtitle?: string
    dictateAndImproveTitle?: string
    dictateAndImproveSubtitle?: string
    testimonialsTitle?: string
    testimonialsSubtitle?: string
    pricingTitle?: string
    pricingSubtitle?: string
    timeSavingsTitle?: string
    timeSavingsSubtitle?: string
    aiChatFeatureTitle?: string
    aiChatFeatureSubtitle?: string
}

const ClientSideLoaded = ({
    hyperAITitle,
    hyperAISubtitle,
    taskWriterTitle,
    taskWriterSubtitle,
    inboxTitle,
    inboxSubtitle,
    aiModelsTitle,
    aiModelsSubtitle,
    dictationTitle,
    dictationSubtitle,
    dictateAndImproveTitle,
    dictateAndImproveSubtitle,
    testimonialsTitle,
    testimonialsSubtitle,
    pricingTitle = "Pricing for teams that ship",
    pricingSubtitle,
    timeSavingsTitle,
    timeSavingsSubtitle,
    aiChatFeatureTitle,
    aiChatFeatureSubtitle
}: ClientSideLoadedProps) => {
    return (
        <>
            <UTMCookieHandler/>
            <Inbox title={inboxTitle} subtitle={inboxSubtitle}/>
            <HyperAI title={hyperAITitle} subtitle={hyperAISubtitle}/>
            <AIChatFeature title={aiChatFeatureTitle} subtitle={aiChatFeatureSubtitle}/>
            <TaskWriter title={taskWriterTitle} subtitle={taskWriterSubtitle}/>
            <AIModels title={aiModelsTitle} subtitle={aiModelsSubtitle}/>
            <Dictation title={dictationTitle} subtitle={dictationSubtitle}/>
            <DictateAndImprove title={dictateAndImproveTitle} subtitle={dictateAndImproveSubtitle}/>
            <TestimonialSingleCard />
            <Testimonials2 />
            <PricingModule headline={pricingTitle} />
            <TimeSavings title={timeSavingsTitle} subtitle={timeSavingsSubtitle}/>
        </>
    )
}

export default ClientSideLoaded